export const SET_DICTIONARY = 'SET_DICTIONARY'
